const CustomResourceApplyZG = () => import('@/views/main/report/customResourceApply/CustomResourceApplyZG.vue')
export default {
  path: '/main/report/customResourceApplyZG',
  name: 'customResourceApplyZG',
  component: CustomResourceApplyZG,
  children: []
}
